// src/pages/Donors.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import DonorTable from '../components/DonorTable';
import DonorForm from '../components/DonorForm';
import Button from '../components/Button';
// import '../styles/donors.css';

const Donors = () => {
  const [donors, setDonors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [currentDonor, setCurrentDonor] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDonors = async () => {
      try {
        const response = await api.get('/donors');
        setDonors(response.data);
      } catch (err) {
        if (err.response?.status === 401) {
          navigate('/login');
        } else {
          setError('Failed to fetch donors');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchDonors();
  }, [navigate]);

  const handleEdit = (donor) => {
    setCurrentDonor(donor);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this donor?')) {
      try {
        await api.delete(`/donors/${id}`);
        setDonors(donors.filter(donor => donor.id !== id));
      } catch (err) {
        setError('Failed to delete donor');
      }
    }
  };

  const handleSubmit = async (formData) => {
    try {
      let response;
      if (currentDonor) {
        response = await api.put(`/donors/${currentDonor.id}`, formData);
        setDonors(donors.map(d => d.id === currentDonor.id ? response.data : d));
      } else {
        response = await api.post('/donors', formData);
        setDonors([...donors, response.data]);
      }
      
      setShowForm(false);
      setCurrentDonor(null);
    } catch (err) {
      setError('Failed to save donor');
    }
  };

  return (
    <div className="donors-page">
      <div className="page-header">
        <h1>Donor Management</h1>
        <Button onClick={() => setShowForm(true)}>Add New Donor</Button>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      {showForm ? (
        <DonorForm 
          donor={currentDonor} 
          onSubmit={handleSubmit} 
          onCancel={() => {
            setShowForm(false);
            setCurrentDonor(null);
          }} 
        />
      ) : (
        <DonorTable 
          donors={donors} 
          loading={loading} 
          onEdit={handleEdit} 
          onDelete={handleDelete} 
        />
      )}
    </div>
  );
};

export default Donors;